<template>
  <div class="">
    <b-modal :id="JSON.stringify(documentId)" title="Document Signoff" size="xl">
      <div v-if="!error">
        <iframe ref="dealerAgreement" :src="src" class="w-100" height="800px" @scroll="scrolling"></iframe>

        <c-card v-if="signature_src" class="my-4">
          <c-card-header>
            <h5 class="font-weight-bold m-0 p-0">Signed on {{ this.signature.created_at | moment('L') }}:</h5>
          </c-card-header>
          <div v-html="signature_src"></div>
          <c-card-footer></c-card-footer>
        </c-card>

        <c-card v-else class="my-4">
          <c-card-header>
            <h5 class="font-weight-bold m-0 p-0">By signing below you are agreeing/accepting the terms of the agreement above:</h5>
          </c-card-header>
          <div>
            <VueSignaturePad width="100%" height="400px" ref="signaturePad" :options="{onBegin: () => {$refs.signaturePad.resizeCanvas()}}" class="border"></VueSignaturePad>
          </div>
          <c-card-footer>
            <b-button-group class="float-right">
              <b-button squared variant="outline-dark" @click="clear">Clear</b-button>
              <b-button squared variant="outline-dark" @click="undo">Undo</b-button>
              <b-button squared variant="outline-success" @click="save">Save</b-button>
            </b-button-group>
          </c-card-footer>
        </c-card>

      </div>
      <b-alert v-else show>{{ error }}</b-alert>
    </b-modal>
  </div>
</template>

<script>
import Document from "../../models/Document";
import ToastNotifications from "../../components/shared/mixins/ToastNotifications";
import Customer from "../../models/Customer";

export default {
  name: 'DocumentSignoffModal',
  mixins: [ToastNotifications],
  props: ['documentId'],
  data() {
    return {
      loading: true,
      error: null,
      signature: null,
      document: null,
      src: null,
      signature_src: null
    };
  },
  methods: {
    init() {
      this.loading = true;
      return this.fetch().then(() => {
        return this.populate().then(() => {
          this.error = null;
          this.loading = false;
        }, this.defaultError);
      }, this.defaultError);
    },
    fetch() {
      return new Promise((resolve, reject) => {
        return Promise.all([
          Document.api().fetch({ id: this.documentId }),
          // Document.api().getSignature()
        ]).then((results) => {
          let document_results = results[0];
          let signature_results = [];
          if(document_results.entities.documents && document_results.entities.documents.length) {
            this.document = document_results.entities.documents[0];
            // if(signature_results.entities.documents && signature_results.entities.documents.length) {
            //   this.signature = signature_results.entities.documents[0];
            // }
            return resolve(this.document);
          } else {
            return reject();
          }
        }, () => {
          //console.log(err);
          return reject();
        });
      });
    },
    populateSignature() {
      Document.api().file(this.signature.id, this.signature.mime_type, false).then(response => {
        this.signature_src = response.response.data;
      });
    },
    populate() {
      let p = [Document.api().file(this.documentId, this.document.mime_type)];
      if(this.signature && this.signature.id) {
        p.push(Document.api().file(this.signature.id, this.signature.mime_type, false));
      }
      return Promise.all(p).then((responses) => {
        let urlCreator = window.URL || window.webkitURL;
        let document_response = responses[0];
        let document_data = document_response.response.data;
        let document_type = this.document.mime_type;
        let document_file = new Blob([document_data], {type: document_type});
        this.src = urlCreator.createObjectURL(document_file);
        if(responses[1]) {
          let signature_response = responses[1];
          this.signature_src = signature_response.response.data;
          //this.signature_src = Buffer.from(signature_response.data, 'binary').toString('base64')
          //let data = signature_response.response.data;
          //let type = this.signature.mime_type;
          //let dom_ele = document.createElement('div');
          //dom_ele.innerHTML = data;
          //let svg_ele = dom_ele.firstChild;
          //let s = new XMLSerializer().serializeToString(svg_ele)
          // //let file = new Blob([data], {type: type});
          // //this.signature_src = urlCreator.createObjectURL(file);
          // //this.signature_src = 'data:' + type + ';base64,' + btoa(unescape(encodeURIComponent(data)));
          //this.signature_src = 'data:' + type + ';base64,' + btoa(s);
          //this.signature_src = 'data:svg+xml;base64,' + btoa(s);
        }
      });
    },
    defaultError(err) {
      console.warn(err);
      this.loading = false;
      return this.error;
    },
    scrolling() {
      console.log(arguments);
    },
    clear() {
      this.$refs.signaturePad.clearSignature();
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      return new Promise((resolve, reject) => {
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature('image/svg+xml');
        if(!isEmpty) {
          let mime_type = 'image/svg+xml';
          let contents = data.replace('data:image/svg+xml;base64,', '');
          const byteCharacters = atob(contents);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: mime_type });
          let formData = new FormData();
          formData.append('file', blob);
          formData.append('document_id', this.documentId);
          Document.api().create(formData).then((response) => {
            let document = response.entities[Document.entity][0];
            Customer.api().saveSignature(document.id).then(() => {
              this.signature = document;
              this.quickSuccessToast('Signature saved', 'The dealer agreement was signed successfully.');
              this.populateSignature();
              return resolve();
            }, () => {
              this.quickWarningToast('Save failed', 'Please try again later.');
              return reject();
            });
          }, () => {
            this.quickWarningToast('Save failed', 'Please try again later.');
            return reject();
          });
        } else {
          this.quickWarningToast('No Signature', 'Please sign in the allocated area before saving.');
          return reject();
        }
      });
    }
  },
  mounted() {
    this.init();
  }
}
</script>

